import React, { useEffect, useMemo, useState } from "react";
import api from "../services/api";

function EditLesson({ lessonId, setPage }) {

const [title,setTitle] = useState("");
const [description,setDescription] = useState("");
const [courseId,setCourseId] = useState("");
const [moduleId,setModuleId] = useState("");
const [hlsLink,setHlsLink] = useState("");
const [homeServerLink,setHomeServerLink] = useState("");
const [status,setStatus] = useState("");

/* DOCUMENT STATES */
const [documentFile,setDocumentFile] = useState(null);
const [allowDownload,setAllowDownload] = useState(false);
const [existingDocument,setExistingDocument] = useState("");

const [courses,setCourses] = useState([]);
const [modules,setModules] = useState([]);

useEffect(()=>{
loadCourses();
loadModules();
loadLesson();
},[]);

const loadCourses = async ()=>{
try{
const res = await api.get("/courses");
setCourses(res.data.data || []);
}catch(err){
console.log(err);
}
};

const loadModules = async ()=>{
try{
const res = await api.get("/modules");
setModules(res.data.data || []);
}catch(err){
console.log(err);
}
};

const loadLesson = async ()=>{
try{

const res = await api.get(`/lessons/${lessonId}`);
const lesson = res.data.data;

setTitle(lesson.title || "");
setDescription(lesson.description || "");
setModuleId(String(lesson.module_id || ""));
setHlsLink(lesson.hls_video_url || "");
setHomeServerLink(lesson.home_server_url || "");
setStatus(lesson.status || "");

setExistingDocument(lesson.document_url || "");
setAllowDownload(lesson.allow_download || false);

const modulesRes = await api.get("/modules");
const allModules = modulesRes.data.data || [];
setModules(allModules);

const module = allModules.find(
(m)=>String(m.id) === String(lesson.module_id)
);

if(module){
setCourseId(module.course_id || "");
}

}catch(err){
console.log(err);
alert("Failed to load lesson");
}
};

const visibleModules = useMemo(()=>{

if(!courseId) return [];

return modules.filter(
(m)=>String(m.course_id) === String(courseId)
);

},[modules,courseId]);

const updateLesson = async ()=>{

if (!title) {
  alert("Title is required");
  return;
}

if (!moduleId) {
  alert("Module is required");
  return;
}

if (!hlsLink && !homeServerLink) {
  alert("Provide Bunny CDN link OR Home Server link");
  return;
}

if (!status) {
  alert("Status is required");
  return;
}

try{

const currentLessonRes = await api.get(`/lessons/${lessonId}`);
const currentLesson = currentLessonRes.data.data;

/* DOCUMENT UPLOAD */

if(documentFile){

const formData = new FormData();

formData.append("module_id", String(moduleId));
formData.append("title", title);
formData.append("description", description);
formData.append("hls_video_url", hlsLink);
formData.append("home_server_url", homeServerLink);
formData.append("duration_seconds", String(currentLesson.duration_seconds || 0));
formData.append("sort_order", String(currentLesson.sort_order || 1));
formData.append("status", status);
formData.append("allow_download", String(allowDownload)); // 🔥 FIXED
formData.append("document", documentFile);


if (!moduleId) {
  alert("Module not selected properly");
  return;
}
await api.put(`/lessons/${lessonId}`,formData,{
headers:{
"Content-Type":"multipart/form-data"
}
});

}

else{

await api.put(`/lessons/${lessonId}`,{

module_id:moduleId,
title,
description,
hls_video_url:hlsLink,
home_server_url:homeServerLink,
duration_seconds:currentLesson.duration_seconds || 0,
sort_order:currentLesson.sort_order || 1,
status,
allow_download:allowDownload

});

}

alert("Lesson updated successfully");

setPage({page:"lessons"});

}catch(err){

console.log(err.response?.data || err);

alert(err.response?.data?.message || "Failed to update lesson");

}

};

return(

<div style={{padding:"30px",maxWidth:"900px"}}>

<h2 style={{marginBottom:"25px"}}>Edit Lesson</h2>

<div style={card}>

{/* TITLE */}

<div style={field}>
<label>Title</label>

<input
style={input}
value={title}
onChange={(e)=>setTitle(e.target.value)}
/>

</div>

{/* DESCRIPTION */}

<div style={field}>

<label>Description</label>

<textarea
style={textarea}
value={description}
onChange={(e)=>setDescription(e.target.value)}
/>

</div>

{/* COURSE */}

<div style={field}>

<label>Course</label>

<select
style={input}
value={courseId}
onChange={(e)=>{
  const selectedCourse = e.target.value;

  setCourseId(selectedCourse);

  // ✅ Only reset if module doesn't belong
  if (!visibleModules.find(m => String(m.id) === String(moduleId))) {
    setModuleId("");
  }
}}
>

<option value="">Select Course</option>

{courses.map((c)=>(
<option key={c.id} value={c.id}>
{c.title}
</option>
))}

</select>

</div>

{/* MODULE */}

<div style={field}>

<label>Module (Topic)</label>

<select
style={input}
value={moduleId}
onChange={(e)=>setModuleId(e.target.value)}
disabled={!courseId}
>

<option value="">Select Module</option>

{visibleModules.map((m)=>(
<option key={m.id} value={m.id}>
{m.title}
</option>
))}

</select>

</div>

{/* BUNNY VIDEO */}

<div style={field}>

<label>Bunny CDN Link (HLS)</label>

<input
style={input}
value={hlsLink}
onChange={(e)=>setHlsLink(e.target.value)}
placeholder="https://cdn..."
/>

</div>

{/* HOME SERVER VIDEO */}

<div style={field}>

<label>MaAz Server Video Link</label>

<input
style={input}
value={homeServerLink}
onChange={(e)=>setHomeServerLink(e.target.value)}
placeholder="https://jta.jackstechnologies.com/..."
/>

</div>

{/* DOCUMENT */}

<div style={field}>

<label>Lesson Document</label>

{existingDocument && (

<div style={{marginBottom:"10px"}}>

<a
href={existingDocument}
target="_blank"
rel="noreferrer"
>
View Current Document
</a>

</div>

)}

<input
type="file"
onChange={(e)=>setDocumentFile(e.target.files[0])}
/>

<div style={{marginTop:"10px"}}>

<label>

<input
type="checkbox"
checked={allowDownload}
onChange={()=>setAllowDownload(!allowDownload)}
/>

{" "}Allow Students To Download

</label>

</div>

</div>

{/* STATUS */}

<div style={field}>

<label>Status</label>

<select
style={input}
value={status}
onChange={(e)=>setStatus(e.target.value)}
>

<option value="">Select</option>
<option value="draft">Draft</option>
<option value="published">Published</option>
<option value="archived">Archived</option>

</select>

</div>

</div>

<div style={{marginTop:"20px"}}>

<button style={primaryBtn} onClick={updateLesson}>
Save Changes
</button>

<button
style={cancelBtn}
onClick={()=>setPage({page:"lessons"})}
>
Cancel
</button>

</div>

</div>

);

}

/* UI */

const card={
background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)"
};

const field={
marginBottom:"18px"
};

const input={
width:"100%",
padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px"
};

const textarea={
width:"100%",
height:"120px",
padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px"
};

const primaryBtn={
background:"#2c3e50",
color:"white",
padding:"10px 18px",
border:"none",
borderRadius:"6px",
marginRight:"10px",
cursor:"pointer"
};

const cancelBtn={
padding:"10px 18px",
borderRadius:"6px",
border:"1px solid #ccc",
cursor:"pointer"
};

export default EditLesson;